export default {"src":"/_next/static/media/nec.226d3c14.svg","height":62,"width":176,"blurWidth":0,"blurHeight":0};